module.exports = __webpack_public_path__ + "images/sprites/ui/arrow_bu_bottom_22109b16df39841a0ba1c1ee7b218a60.png";